// where the visitor came from: the public site keeps it in a cookie for the whole domain after its cookie consent
// (see psy-frontend-prod/src/utils/attribution.js); the cabinet only reads it for the registration
function readCookie(name) {
  const row = document.cookie.split("; ").find((item) => item.indexOf(name + "=") === 0);
  return row ? decodeURIComponent(row.slice(name.length + 1)) : null;
}

export function getAttribution() {
  if (typeof document === "undefined" || readCookie("pl_consent") !== "all") return null;
  try {
    return JSON.parse(readCookie("pl_attr") || "null");
  } catch (e) {
    return null;
  }
}
